import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { SocketContext } from "../../../context/Socket/SocketContext";
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { i18n } from "../../../translate/i18n";
import { priceLocale } from "../Forms/PaymentForm";

function CheckoutSuccess(props) {

  const { pix } = props;
  const [pixString,] = useState(pix.qrcode.qrcode);
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  const { dateToClient } = useDate();

  const socketManager = useContext(SocketContext);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);
    
    socket.on(`company-${companyId}-payment`, (data) => {

      if (data.action === "CONCLUIDA") {
        toast.success(i18n.t("financial.checkout.renewed", { date: dateToClient(data.company.dueDate) }));
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    });
  }, [dateToClient, history, socketManager]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  return (
    <React.Fragment>
      <Total>
        <span>TOTAL</span>
        <strong>${Number(pix.valor.original || 0).toLocaleString(priceLocale(), { minimumFractionDigits: 2 })}</strong>
      </Total>
      <SuccessContent>
        <QRCode value={pixString} />
        <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
          <button className="copy-button" type="button">
            {copied ? (
              <>
                <span>{i18n.t("financial.checkout.copied")}</span>
                <FaCheckCircle size={18} />
              </>
            ) : (
              <>
                <span>{i18n.t("financial.checkout.copyQr")}</span>
                <FaCopy size={18} />
              </>
            )}
          </button>
        </CopyToClipboard>
        <span>
          {i18n.t("financial.checkout.pixHint")}
        </span>
      </SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
